module.exports = __webpack_public_path__ + "img/cost.71dd0b28.svg";